import * as React from "react";
import { Button, MiniModal, ButtonUse } from "react-ui";
import { useEffect } from "react";

import { useMetrics } from "../../../../../../Controls/Internals/Metrics/MetricsProviderContext";
import {
    MODAL_FORM_CONFIRM_ACCEPT,
    MODAL_FORM_CONFIRM_CANCEL,
    MODAL_FORM_CONFIRM_OPEN,
} from "../../../../../../Controls/metricsAction";
import { InternalIcon } from "../../../../../../Controls/Icons/Icon";

export type MiniModalButtonsDirection = "row" | "column";

export interface ConfirmMiniModalProps {
    text: string | React.ReactNode;
    headerText?: string;
    confirmButtonText: string;
    discardButtonText?: string;
    onConfirm: () => void;
    onDiscard?: () => void;
    path?: string;
    iconName?: string;
    submitButtonUse?: ButtonUse;
    width?: string;
    buttonsDirection?: MiniModalButtonsDirection;
}

export function ConfirmMiniModal(props: ConfirmMiniModalProps): JSX.Element {
    const track = useMetrics();

    useEffect(() => {
        if (props.path) {
            track(MODAL_FORM_CONFIRM_OPEN, { path: props.path });
        }
    }, []);

    const onConfirm = () => {
        props.onConfirm();

        if (props.path) {
            track(MODAL_FORM_CONFIRM_ACCEPT, { path: props.path });
        }
    };

    const onDiscard = () => {
        if (!props.onDiscard) {
            return;
        }

        props.onDiscard();

        if (props.path) {
            track(MODAL_FORM_CONFIRM_CANCEL, { path: props.path });
        }
    };

    let icon = null;

    if (props.iconName) {
        icon = <InternalIcon name={props.iconName} size={64} />;
    }

    return (
        <MiniModal ignoreBackgroundClick={true} onClose={onDiscard} width={props.width ?? 400}>
            <MiniModal.Header icon={icon}>{props.headerText ?? "Подтверждение"}</MiniModal.Header>
            <MiniModal.Body>{props.text}</MiniModal.Body>
            <MiniModal.Footer direction={props.buttonsDirection}>
                <Button
                    size={"medium"}
                    use={props.submitButtonUse ?? "primary"}
                    onClick={onConfirm}
                    data-tid={"miniModalConfirm"}>
                    {props.confirmButtonText}
                </Button>
                {props.onDiscard != undefined ? (
                    <Button size={"medium"} data-tid={"miniModalCancel"} onClick={onDiscard}>
                        {props.discardButtonText ?? "Отмена"}
                    </Button>
                ) : null}
            </MiniModal.Footer>
        </MiniModal>
    );
}
